export const is_ipad = () => (window.innerWidth >= 813 && window.innerWidth
    <= 1025);
